module.exports = __webpack_public_path__ + "img/lx_dplb.d3676278.svg";